import { render, staticRenderFns } from "./transactionsFilters.vue?vue&type=template&id=21823d1a"
import script from "./transactionsFilters.vue?vue&type=script&lang=js"
export * from "./transactionsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports